import { render, staticRenderFns } from "./layout-product-card.vue?vue&type=template&id=b3a3c3c4&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./layout-product-card.vue?vue&type=script&lang=js"
export * from "./layout-product-card.vue?vue&type=script&lang=js"
import style0 from "./layout-product-card.vue?vue&type=style&index=0&id=b3a3c3c4&prod&lang=scss&scoped=true"
import style1 from "./layout-product-card.vue?vue&type=style&index=1&id=b3a3c3c4&prod&lang=scss"
import style2 from "./layout-product-card.vue?vue&type=style&index=2&id=b3a3c3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3c3c4",
  null
  
)

export default component.exports